import { Toaster as HotToaster } from 'react-hot-toast';

export default function Toaster() {
    return (
        <HotToaster
            position="top-right"
            toastOptions={{
                className: '',
                duration: 4000,
                style: {
                    background: '#fff',
                    color: '#333',
                    boxShadow: '0 0.5rem 1rem rgba(219, 25, 94, 0.15)',
                    borderRadius: '0.5rem',
                    padding: '1rem',
                    fontSize: '0.875rem',
                },
                success: {
                    iconTheme: {
                        primary: '#db195e',
                        secondary: '#fff',
                    },
                    style: {
                        borderLeft: '4px solid #db195e',
                        background: '#fbe6eb',
                    },
                },
                error: {
                    iconTheme: {
                        primary: '#db195e',
                        secondary: '#fff',
                    },
                    style: {
                        borderLeft: '4px solid #db195e',
                        background: '#fbe6eb',
                    },
                },
            }}
        />
    );
} 